import {MY_TEAMS} from '/enum/records.enum';

export default {
  reportName: MY_TEAMS,
};
